import * as tslib_1 from "tslib";
import { PaginatedPlaceResult } from './paginated-place-result.model';
/**
 * Helper class that facilitates loading paginated result sets from the Google Places API.
 */
var PlaceResultLoader = /** @class */ (function () {
    function PlaceResultLoader(_retrieve, _handler) {
        this._retrieve = _retrieve;
        this._handler = _handler;
        this._promise = null;
    }
    PlaceResultLoader.prototype.getResults = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                this._promise = new Promise(function (resolve, reject) {
                    _this._resolve = resolve;
                    _this._reject = reject;
                });
                this._retrieve(this._onResults.bind(this));
                return [2 /*return*/, this._promise];
            });
        });
    };
    PlaceResultLoader.prototype.loadPage = function (pagination) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this._promise = new Promise(function (resolve, reject) {
                            _this._resolve = resolve;
                            _this._reject = reject;
                        });
                        pagination.nextPage();
                        return [4 /*yield*/, this._promise];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    PlaceResultLoader.prototype._onResults = function (places, status, pagination) {
        try {
            var result = new PaginatedPlaceResult();
            if (status === google.maps.places.PlacesServiceStatus.OK) {
                result.places = this._handler ? this._handler(places) : places;
            }
            else if (status === google.maps.places.PlacesServiceStatus.ZERO_RESULTS) {
                result.places = [];
            }
            else {
                this._reject(new Error(status));
            }
            result.pagination = pagination;
            this._resolve(result);
        }
        catch (e) {
            this._reject(e);
        }
    };
    return PlaceResultLoader;
}());
export { PlaceResultLoader };
